import { useLanguage } from '../../context/LanguageContext';
import SEOHead from '../../components/common/SEOHead';
import { usePageSeo } from '../../hooks/useSeoConfig';
import HeroLanding from './sections/landing/HeroLanding';
import PlatformSection from './sections/landing/PlatformSection';
import FeaturesSection from './sections/landing/FeaturesSection';
import AuthoritySection from './sections/landing/AuthoritySection';
import StatsSection from './sections/landing/StatsSection';
import LevelsLanding from './sections/landing/LevelsLanding';
import PartnerSection from './sections/landing/PartnerSection';
import FounderCTA from './sections/landing/FounderCTA';

function Home() {
    const { language } = useLanguage();
    const seo = usePageSeo('page_home');

    const jsonLd = {
        "@context": "https://schema.org",
        "@type": "EducationalOrganization",
        "name": "Nizus Online Pilot Training",
        "url": "https://www.nizus.com",
        "description": language === 'fr'
            ? "Plateforme de formation en ligne pour les examens aéronautiques de Transports Canada"
            : "Online training platform for Transport Canada aeronautical exams",
    };

    return (
        <main className="bg-white dark:bg-[#0f0f0f]">
            <SEOHead
                title={language === 'fr' ? (seo.title_fr || 'Nizus - Formation pilote en ligne') : (seo.title_en || 'Nizus - Online Pilot Training')}
                description={language === 'fr' ? (seo.desc_fr || 'Plateforme de formation pour les examens aéronautiques de Transports Canada.') : (seo.desc_en || 'Training platform for Transport Canada aeronautical exams.')}
                keywords={language === 'fr' ? seo.keywords_fr : seo.keywords_en}
                canonical="/"
                jsonLd={jsonLd}
            />
            <HeroLanding language={language} />
            <PlatformSection language={language} />
            <FeaturesSection language={language} />
            <AuthoritySection language={language} />
            <StatsSection language={language} />
            <LevelsLanding language={language} />
            <PartnerSection language={language} />
            <FounderCTA language={language} />
        </main>
    );
}

export default Home;
